import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
// Self-hosted fonts: loading them from Google would send every visitor's IP there.
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import '@fontsource/inter/800.css';
import '@fontsource/orbitron/400.css';
import '@fontsource/orbitron/700.css';
import './index.css';
import { AuthProvider } from './contexts/AuthContext';
import { I18nProvider } from './i18n';

// Loaded only in preview mode, so the whole game does not ship in the entry chunk.
const KartLifePreview = React.lazy(() => import('./kartlifePreview'));

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <I18nProvider>
      <AuthProvider>
        {process.env.REACT_APP_KARTLIFE_PREVIEW === 'true'
          ? <Suspense fallback={null}><KartLifePreview /></Suspense>
          : <App />}
      </AuthProvider>
    </I18nProvider>
  </BrowserRouter>
);

if ('serviceWorker' in navigator && process.env.REACT_APP_GAMES_STAGING !== 'true') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').catch(() => {});
  });
}
